import { DocumentType } from './use-examples/sample.model';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FileService } from 'app/files/file.service';
import { IFile } from 'app/files/file.model';
import { IInputFile, IWizardFile } from 'app/files/file.model';
import { Order } from 'app/orders/order.model';
import { OrderService, OrderCreateSettings } from 'app/orders/order.service';
import { ServiceType } from 'app/core/service-type.model';
import { Application } from 'app/applications/application.model';

class WizardStatistics {
  files: number;

  constructor() {
    this.reset();
  }

  reset(): void {
    this.files = 0;
  }

}

interface IWizardCreate {
  application?: Application;
  format: string;
  region: string;
  verification: string;
  serviceType: ServiceType;
  document_type: DocumentType;
}

enum FileStateProgress {
  upload = 98,
  uploaded = 99,
  ready = 100
}

@Injectable()
export class WizardService {

  created = new EventEmitter<Order>();

  files: IWizardFile[] = [];

  statistics: WizardStatistics = new WizardStatistics();

  constructor(
    private _fileService: FileService,
    private _orderService: OrderService) {
  }

  create(data: IWizardCreate | any, serviceType: ServiceType): Observable<Order> {
    const settings: OrderCreateSettings | any = {
      files: this.files.map(file => {
        return { id: file.id, token: file.token }
      }),
      application: data.application,
      document_type: data.document_type
    };
    if (data.verification) {
      settings.verification = data.verification;
    }
    if (serviceType === 'ic') {
      settings.region = data.region;
      settings.export_format = data.export_format;
    } else {
      Object.assign(settings, data);
    }
    return this._orderService.create(settings, serviceType).pipe(tap(order => this.created.emit(order)));
  }

  filesReady(): boolean {
    return (this.files.length > 0 && this.files.every(file => file.progress === FileStateProgress.ready));
  }

  removeFile(file: IWizardFile): void {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this._fileService.remove(file).subscribe();
      this.files.splice(index, 1);
    }
    if (!this.files.length) {
      this.reset();
    } else {
      this._recalculate();
    }
  }


  reset(): void {
    this.files.splice(0, this.files.length);
    this.statistics.reset();
  }

  upload(files: IInputFile[]): void {
    files.map(file => {
      const wizardFile: IWizardFile = Object.assign(file, { progress: 0 });
      this.files.push(wizardFile);
      if (!file.error) {
        this._fileService.upload(file)
          .subscribe((uploadedFile: IFile | number) => {
            if (typeof uploadedFile === 'number') {
              wizardFile.progress = uploadedFile * (FileStateProgress.upload / 100);
            } else {
              wizardFile.id = uploadedFile.id;
              wizardFile.progress = FileStateProgress.ready;
              wizardFile.token = uploadedFile.token;
              this._recalculate();
            }
          });
      }
    });
  }

  private _recalculate(): void {
    this.statistics.reset();
    this.files.forEach(() => this.statistics.files += 1);
  }
}
